import { supabase } from '../../core/config/supabase';
import { logger } from '@/src/core/utils';

export interface UserSearchResult {
  id: string;
  email: string;
  fullName?: string;
}

export class SearchUserByEmailUseCase {
  async execute(email: string): Promise<UserSearchResult | null> {
    logger.debug('SearchUserByEmail', 'Searching for user by email', { email });

    if (!email.trim()) {
      throw new Error('Email is required');
    }

    try {
      // Buscar usuario en auth.users mediante RPC function
      // Nota: Necesitaremos crear una función RPC en Supabase para esto
      const { data, error } = await supabase.rpc('search_user_by_email', {
        search_email: email.toLowerCase().trim()
      });

      if (error) {
        logger.error('SearchUserByEmail', 'Failed to search user', { error });
        return null;
      }

      if (!data || data.length === 0) {
        logger.debug('SearchUserByEmail', 'User not found');
        return null;
      }

      const user = data[0];
      logger.debug('SearchUserByEmail', 'User found', { email: user.email });

      return {
        id: user.id,
        email: user.email,
        fullName: user.raw_user_meta_data?.full_name,
      };
    } catch (error) {
      logger.error('SearchUserByEmail', 'Failed to search user by email', { error });
      return null;
    }
  }
}
